import { c as _c } from "react/compiler-runtime";
import { IconButtonAsButton, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@newfront-insurance/core-ui/v2';
import { useChatOverlayContext } from '../../contexts/chat-overlay-context';
import { IconSidebar } from '../icons';
interface ToggleSidebarProps {
  className?: string;
}

/**
 * Button component for toggling sidebar visibility.
 * Uses chat overlay context to manage sidebar state.
 */
export function ToggleSidebar(t0) {
  const $ = _c(10);
  const {
    className
  } = t0;
  const {
    isSidebarOpen,
    setIsSidebarOpen
  } = useChatOverlayContext();
  let t1;
  if ($[0] !== isSidebarOpen || $[1] !== setIsSidebarOpen) {
    t1 = e => {
      e.stopPropagation();
      setIsSidebarOpen(!isSidebarOpen);
    };
    $[0] = isSidebarOpen;
    $[1] = setIsSidebarOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconSidebar />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== t1) {
    t3 = <TooltipTrigger asChild={true}><IconButtonAsButton onClick={t1} className={className}>{t2}</IconButtonAsButton></TooltipTrigger>;
    $[4] = className;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TooltipContent className="z-[1400]">Toggle Sidebar</TooltipContent>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <TooltipProvider><Tooltip>{t3}{t4}</Tooltip></TooltipProvider>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}